'use client';

import { useLegalNotices } from './LegalNoticesProvider';

export default function SiteFooter() {
  const { openLegalNotices } = useLegalNotices();

  return (
    <span></span>
  );
}
